import React from 'react';
import { useDispatch } from 'react-redux';
import { REMOVE_FROM_CART, UPDATE_CART_QUANTITY } from "../../utils/actions";
import { idbPromise } from "../../utils/helpers";

const CartItem = ({ item }) => {

  const dispatch = useDispatch();

  const removeFromCart = item => {
    dispatch({
      type: REMOVE_FROM_CART,
      _id: item._id
    });
    idbPromise('cart', 'delete', { ...item });
  };

  const onChange = (e) => {
    const value = e.target.value;
    if (value === '0') {
      dispatch({
        type: REMOVE_FROM_CART,
        _id: item._id
      });
      idbPromise('cart', 'delete', { ...item });
    } else {
      dispatch({
        type: UPDATE_CART_QUANTITY,
        _id: item._id,
        purchaseQuantity: parseInt(value)
      });
      idbPromise('cart', 'put', { ...item, purchaseQuantity: parseInt(value) });
    }
  }

  return (
    <div className="flex-row">
      <div>
        <img src={`/images/${item.image}`} alt="{item.name}" />
      </div>
      <div>
        <div>{item.name}, ${item.price_usd}</div>
        {item.inStock ? (
            <div>
              <span>Qty:</span>
              <input
                name="quantity"
                type="number"
                placeholder="1"
                value={item.purchaseQuantity}
                onChange={onChange}
              />
              <span className="link" onClick={() => removeFromCart(item)}>Remove</span>
            </div>
          ) : (
            <>
              <div className="out-of-stock">Out of stock</div>
              <span className="link" onClick={() => removeFromCart(item)}>Remove</span>
            </>
          )}
      </div>
    </div>
  );
}

export default CartItem;